import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { UnstyledLink } from '../../../typography/UnstyledLink'
import { Link } from '../../../typography/Link'
import { Tag } from '../../../tag'
import { DepartmentSection } from './DepartmentSection'
import * as styles from './JobBoard.module.scss'

const JobBoard = ({ jobs }) => {
  // Need to add the logic to break the jobs into the appropriate departments
  const numberOfJobs = jobs.length
  const sortedJobs = jobs.reduce((finalArray, item) => {
    const jobsItem = {
      absoluteURL: item.absolute_url,
      role: item.title,
      location: item.location,
      roleType: item.employment_type,
    }

    const jobsList = finalArray.find(i => i.department === item.department)

    if (jobsList) {
      jobsList.jobs.push(jobsItem)
    } else {
      finalArray.push({
        department: item.department,
        jobs: [jobsItem],
      })
    }
    return finalArray
  }, [])
  const sortedLength = sortedJobs.length
  sortedJobs.sort((a, b) => a.department.localeCompare(b.department))

  // Get the departments that are present in the listed jobs
  return (
    <div className={styles.jobBoard}>
      <div className={styles.openPositionCount} aria-live="assertive">
        {numberOfJobs === 1 && <p>{numberOfJobs} OPEN POSITION</p>}
        {numberOfJobs !== 1 && <p>{numberOfJobs} OPEN POSITIONS</p>}
      </div>
      <div className={styles.jobBoardContainer}>
        <table>
          <tr className={styles.headingRow}>
            <th className={styles.department} aria-label="Department" scope="col">
              <p>Department</p>
            </th>
            <th className={styles.role} aria-label="Role" scope="col">
              <p>Role</p>
            </th>
            <th className={styles.location} aria-label="Location" scope="col">
              <p>Location</p>
            </th>
            <th className={styles.roleType} aria-label="Role Type" scope="col">
              <p>Role Type</p>
            </th>
          </tr>
          <div className={styles.departmentRow}>
            {/* This div will contain all of the rows (1 row per department) and that row will contain all of the listings inside that department  */}
            {numberOfJobs === 0 && (
              <div className={styles.noResultText} aria-live="assertive">
                <p>
                  Sorry, we couldn’t find any results matching your request. Please try a different
                  combination or clear all filters to start over.
                </p>
              </div>
            )}
            {sortedJobs.map((job, i) => {
              return (
                <DepartmentSection
                  department={job.department}
                  jobs={job}
                  i={i}
                  length={sortedLength}
                />
              )
            })}
          </div>
        </table>
      </div>
    </div>
  )
}

export { JobBoard }
export default JobBoard
